// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"5ofTu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JumblePageElement", ()=>JumblePageElement);
var _tsDecorate = require("@swc/helpers/_/_ts_decorate");
var _lit = require("lit");
var _decoratorsJs = require("lit/decorators.js");
var _form = require("../css/form");
var _reset = require("../css/reset");
var _stack = require("../css/stack");
var _type = require("../css/type");
var _wordList = require("../wordList");
var _wordListElement = require("../wordListElement");
var _jumble = require("./jumble");
// Only lower case letters.
const normalizePattern = (pattern)=>pattern.toLowerCase().replace(/[^a-z]/g, "");
class JumblePageElement extends (0, _lit.LitElement) {
    constructor(){
        super();
        this.letters = "wefrlo";
        this.words = [];
        this.loading = true;
        this.jumble = (0, _wordList.wordListPromise).then((words)=>new (0, _jumble.Jumble)(words));
        this.updateWords();
    }
    onLettersChange(event) {
        const target = event.target;
        this.letters = normalizePattern(target.value);
        // A hack? to make sure the input's displayed value updates when the new
        // value undoes the change the user just made. Without this, the framework
        // sees "no change" and the user's change isn't undone.
        // https://github.com/Polymer/lit-element/issues/144#issuecomment-468098257
        target.value = this.letters;
        this.updateWords();
    }
    async updateWords() {
        this.loading = true;
        const jumble = await this.jumble;
        this.words = jumble.matches(this.letters);
        this.loading = false;
    }
    static get styles() {
        return [
            (0, _reset.resetCss),
            (0, _stack.stackCss),
            (0, _type.typeCss),
            (0, _form.formCss)
        ];
    }
    render() {
        return (0, _lit.html)`
      <div class="stack">
        <p>
          Enter your jumbled letters to see how to rearrange them into a word.
        </p>

        <div>
          <label for="letters">The jumbled letters</label>
          <input
              id="letters"
              class="puzzle-input"
              autofocus
              spellcheck="false"
              .value="${this.letters}"
              @input="${this.onLettersChange}">
        </div>

        <div>
          <h2>See the ${this.letters.length && this.loading ? "" : this.words.length} unscrambled words</h2>

          ${this.loading ? (0, _lit.html)`<p>Loading&hellip;</p>` : null}

          ${!this.loading && this.letters.length && this.words.length === 0 ? (0, _lit.html)`
            <p>
              🤔 We can't find a way to make a word with the letters
              "${this.letters}".
            </p>
            <p>
              Try our Scrabble solver
              "${this.letters}".
            </p>
          ` : null}

          <!--
            With enable2k.txt, the max result size is just 9 words.
            No need for limits.
          -->
          <mw-word-list .words="${this.words}"></mw-word-list>
        </div>
      </div>
    `;
    }
}
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], JumblePageElement.prototype, "letters", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], JumblePageElement.prototype, "words", void 0);
(0, _tsDecorate._)([
    (0, _decoratorsJs.state)()
], JumblePageElement.prototype, "loading", void 0);
JumblePageElement = (0, _tsDecorate._)([
    (0, _decoratorsJs.customElement)("mw-jumble-page")
], JumblePageElement);

},{"@swc/helpers/_/_ts_decorate":"3Z6vO","lit":"aCmte","lit/decorators.js":"kQrIl","../css/form":"8MMj0","../css/reset":"lBn3n","../css/stack":"812mT","../css/type":"9FxKK","../wordList":"5Ye1N","../wordListElement":"4NDBJ","./jumble":"lJFG0","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lJFG0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given a lexicon, creates an accelerator for looking up word letter jumble
 * solutions.
 */ parcelHelpers.export(exports, "Jumble", ()=>Jumble);
function wordToKey(word) {
    return [
        ...word
    ].sort().join("");
}
class Jumble {
    constructor(words){
        this.keyToWords = new Map();
        for (const word of words){
            const key = wordToKey(word);
            let matchingWords = this.keyToWords.get(key);
            if (matchingWords === undefined) {
                matchingWords = [];
                this.keyToWords.set(key, matchingWords);
            }
            matchingWords.push(word);
        }
    }
    matches(word) {
        const key = wordToKey(word);
        return this.keyToWords.get(key) || [];
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["5ofTu"], "5ofTu", "parcelRequire85a9")

//# sourceMappingURL=index.b49eb75d.js.map
